const Logo = ({ className = "w-12 h-12" }) => {
  const handleImageError = (e) => {
    console.log('❌ Logo image failed to load:', e.target.src);
    console.log('Falling back to text logo');
    // Fallback to text if image fails to load
    e.target.style.display = 'none';
    e.target.nextSibling.style.display = 'flex';
  };

  const handleImageLoad = () => {
    console.log('✅ Logo image loaded successfully');
  };

  return (
    <div className={`${className} relative flex items-center justify-center`}>
      <img 
        src="/aditya-gurav-logo.png" 
        alt="Aditya Gurav Organisation - Team Incredible" 
        className="w-full h-full object-contain"
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
      {/* Fallback content */}
      <div 
        className="w-full h-full bg-emerald-600 rounded-full flex items-center justify-center text-white font-bold" 
        style={{display: 'none'}}
      >
        A.G.O
      </div>
    </div>
  );
};

export default Logo;